import { z } from "zod";
import { PaymentTypeEnum } from "@repo/core/enums/payments";
import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";
import { ConsultProfileClientResponseDTO } from "@repo/core/services/entities/Client";

export interface PaymentValidationParams {
  value: string;
  paymentType: PaymentTypeEnum;
  invoiceInfo?: CardConsultDataResponseDTO["objFatura"] | undefined;
  dealInfo?: ConsultProfileClientResponseDTO[0]["lstAcordos"][0] | undefined;
  invoiceMinValue?: number | null;
  dealMinValue?: number | null;
}

export const validatePaymentValue = (
  params: PaymentValidationParams
): z.IssueData[] => {
  const {
    value,
    paymentType,
    invoiceInfo,
    dealInfo,
    invoiceMinValue,
    dealMinValue
  } = params;
  const issues: z.IssueData[] = [];

  if (value && !invoiceInfo && !dealInfo) {
    if (paymentType === PaymentTypeEnum.INVOICE && !invoiceInfo) {
      issues.push({
        code: z.ZodIssueCode.custom,
        message: "É necessário informar o CPF para realizar o pagamento."
      });
    }
    if (paymentType === PaymentTypeEnum.DEAL && !dealInfo) {
      issues.push({
        code: z.ZodIssueCode.custom,
        message:
          "É necessário informar o número do cartão para realizar o pagamento."
      });
    }
  }

  if (
    paymentType === PaymentTypeEnum.INVOICE &&
    invoiceInfo &&
    !invoiceMinValue
  ) {
    issues.push({
      code: z.ZodIssueCode.custom,
      message: "Não é possivel realizar pagamento de faturas zeradas"
    });
  }

  if (paymentType === PaymentTypeEnum.DEAL && dealInfo && !dealMinValue) {
    issues.push({
      code: z.ZodIssueCode.custom,
      message: "Não é possivel realizar pagamento de acordos zerados"
    });
  }

  const numValue = parseFloat(value.replace(",", "."));

  if (paymentType === PaymentTypeEnum.INVOICE) {
    if (isNaN(numValue) || (invoiceMinValue && numValue < invoiceMinValue)) {
      issues.push({
        code: z.ZodIssueCode.custom,
        message: `O valor mínimo para pagamento é ${invoiceMinValue?.toFixed(2)}`
      });
    }
  } else {
    if (isNaN(numValue) || (dealMinValue && numValue !== dealMinValue)) {
      issues.push({
        code: z.ZodIssueCode.custom,
        message: `O valor mínimo para pagamento é ${dealMinValue?.toFixed(2)}`
      });
    }
  }

  return issues;
};
